'use client';

import { CheckIcon, CopyIcon } from '@repo/icons';
import { cn } from '@repo/utils/cn';
import { copyToClipboard } from '@repo/utils/copy-to-clipboard';
import { useState } from 'react';
import { Button } from '../button';

type CopyButtonProps = {
  copyContent?: string;
  text?: string;
  copiedText?: string;
  onlyIcon?: boolean;
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
  variant?: 'primary' | 'secondary' | 'inverted' | 'blank' | null | undefined;
  copyTimeout?: number;
};

export const CopyButton = ({
  copyContent,
  text = 'Copy',
  copiedText = 'Copied!',
  variant,
  onlyIcon,
  disabled,
  className,
  iconClassName,
  copyTimeout = 2000,
}: CopyButtonProps) => {
  const [isCopied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await copyToClipboard(copyContent);
      setCopied(true);

      const timer = setTimeout(() => {
        setCopied(false);
      }, copyTimeout);

      return () => clearTimeout(timer);
    } catch (error) {
      console.error('CopyButton :: Failed to copy text ::', error);
    }
  };

  return (
    <Button
      disabled={disabled}
      onClick={handleCopy}
      variant={variant ? variant : onlyIcon ? 'blank' : 'tertiary'}
      className={className}
      data-testid="copy-button"
    >
      {isCopied ? (
        <>
          <CheckIcon className={cn(onlyIcon && 'size-5', 'animate-in fade-in', iconClassName)} />
          {!onlyIcon && <span>{copiedText}</span>}
        </>
      ) : (
        <>
          <CopyIcon className={cn(onlyIcon && 'size-5', 'animate-in fade-in', iconClassName)} />
          {!onlyIcon && <span>{text}</span>}
        </>
      )}
    </Button>
  );
};
